import {
  FaHeadphones,
  FaWhatsapp,
  FaSkype,
  FaEnvelope,
  FaInstagram,
} from "react-icons/fa";

export default function Footer() {
  return (
    <>
      <div className="hidden md:flex w-full py-10 flex flex-col items-center">
        {/* ---------- TOP CONTACT BOXES ---------- */}
        <div className="w-full max-w-4xl flex flex-col gap-3 items-center">
          <div className="flex gap-2">
            {/* Customer Support */}
            <div className="w-[350px] bg-white rounded-xl shadow-sm border p-2 flex items-center justify-center gap-3 h-[60px] bg-white py-2 rounded-lg border border-[rgba(151,151,151,0.5)] text-[13px] justify-center">
              <svg
                width="26"
                height="26"
                viewBox="0 0 160 160"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M125.436 95.33c-.453 4.682-2.987 7.98-7.26 9.898-.83.372-1.207.754-1.295 1.729-.542 5.899-4.402 10.21-9.985 11.099-2.427.386-4.905.057-6.92.131-2.593 0-4.746.017-6.9-.01-.675-.008-1.012.24-1.248.888-1.268 3.486-3.987 5.356-7.713 5.361-2.928.006-5.855.011-8.782-.003-3.507-.017-6.301-1.867-7.428-4.89-1.2-3.216-.33-6.768 2.216-9.03 1.487-1.322 3.295-1.814 5.217-1.848a287 287 0 0 1 9.085-.007c3.334.044 6.2 2.077 7.333 5.224.277.77.65 1.032 1.45 1.024 3.904-.035 7.807.005 11.71-.023 4.399-.031 7.776-2.947 8.492-7.278.194-1.175.053-1.34-1.162-1.35-.673-.004-1.347 0-2.02 0-3.092-.006-4.605-1.5-4.606-4.566-.003-7.167-.001-14.334-.001-21.501 0-2.12-.013-4.24.004-6.36.02-2.525 1.276-4.055 3.782-4.244 3.402-.256 6.834-.295 9.92 1.514 4.001 2.346 6.15 5.912 6.243 10.526.093 4.57.31 9.157-.132 13.717M50.55 63.55c-.13.63-.317 1.05-1.07 1.061-2.795.044-5.566.365-8.318.833-.733.124-.94-.057-.873-.83.622-7.134 3.087-13.56 7.561-19.14 3.844-4.796 8.788-8.626 14.517-10.895 5.509-2.18 11.492-2.866 17.418-2.83 1.734.011 3.464.084 5.174.199 2.638.177 5.28.404 7.882.89 2.809.517 5.68 1.71 8.227 2.993a35.227 35.227 0 0 1 12.46 10.468c3.323 4.49 5.52 9.757 6.478 15.256.09.515.169 1.032.237 1.55.11.838.145 1.673.18 2.513.019.432-.152.558-.543.375-2.894-1.351-5.982-1.453-9.09-1.384-.745.016-1.047-.272-1.206-1.008-1.717-7.993-6.139-14.007-13.31-17.955a24.249 24.249 0 0 0-11.19-3.032 173.892 173.892 0 0 0-9.89-.002c-6.253.192-11.744 2.422-16.417 6.572-4.342 3.856-7.055 8.682-8.227 14.367m4.202 38.236c-.004 2.884-1.553 4.472-4.417 4.436-2.25-.029-4.51.22-6.747-.185-4.812-.87-8.388-4.805-8.648-9.688-.308-5.777-.321-11.563.016-17.34.273-4.676 4.606-8.957 9.263-9.363 1.983-.172 3.963-.172 5.946-.147 3.076.04 4.585 1.582 4.588 4.636.004 4.575.001 9.149 0 13.724 0 4.643.005 9.285-.001 13.927M79.52 0h-.04C35.646 0 0 35.656 0 79.5c0 17.39 5.605 33.509 15.135 46.597L5.227 155.63l30.558-9.769C48.355 154.19 63.351 159 79.52 159c43.834 0 79.48-35.666 79.48-79.5S123.354 0 79.52 0"
                  fill="rgb(166,166,166)"
                  fill-rule="nonzero"
                />
              </svg>
              <span className="text-[#00000080] text-[13px]">
                Customer support1
              </span>
              <span className="text-gray-400">|</span>
              <span className="text-[#00000080] text-[13px]">support2</span>
            </div>

            {/* Whatsapp */}
            <div className="w-[350px] bg-white rounded-xl shadow-sm border p-2 flex items-center justify-center gap-3 h-[60px] bg-white py-2 rounded-lg border border-[rgba(151,151,151,0.5)] text-[13px] justify-center">
              <svg width="22" height="22" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.002 1h-.005C5.485 1 1 5.485 1 11c0 2.188.705 4.215 1.904 5.861l-1.246 3.715L5.5 19.347A9.913 9.913 0 0011.002 21C16.517 21 21 16.514 21 11S16.516 1 11.002 1zm5.82 14.121c-.242.681-1.2 1.246-1.963 1.412-.523.11-1.205.2-3.503-.753-2.938-1.218-4.831-4.204-4.978-4.398-.142-.193-1.188-1.58-1.188-3.016 0-1.435.729-2.134 1.022-2.434.242-.246.64-.358 1.023-.358.124 0 .235.006.335.011.294.012.441.03.635.494.241.581.829 2.016.899 2.163.071.148.142.348.042.542-.094.2-.176.288-.324.458-.147.17-.287.3-.434.483-.136.159-.288.329-.118.622.17.288.758 1.247 1.623 2.017 1.116.993 2.02 1.311 2.345 1.446.24.1.528.076.705-.111.223-.242.5-.642.78-1.035.2-.283.453-.318.718-.218.27.094 1.699.8 1.993.946.293.148.487.218.558.342.07.123.07.705-.17 1.387z"
                  fill="rgb(166,166,166)"
                  fill-rule="nonzero"
                />
              </svg>
              <span className="text-[#00000080] text-[13px]">WhatsApp 3</span>
              <span className="text-gray-400">|</span>
              <span className="text-[#00000080] text-[13px]">WhatsApp 4</span>
            </div>
          </div>

          {/* Space */}
          <div className="w-[700px] bg-white rounded-xl shadow-sm border flex items-center justify-center gap-3 h-[20px] bg-white rounded-lg border border-[rgba(151,151,151,0.5)] text-[13px] justify-center"></div>

          {/* Bottom Contact Row */}
          <div className="w-[700px] flex items-center justify-between gap-2 flex-wrap">
            <div className="max-w-[300px] bg-white rounded-xl shadow-sm border p-4 flex items-center gap-3 flex-1 justify-center border border-[rgba(151,151,151,0.5)]">
              <svg width="22" height="22" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M20.425 13.123c.145-.652.22-1.327.22-2.02 0-5.193-4.27-9.404-9.539-9.404-.555 0-1.1.047-1.631.137A5.567 5.567 0 006.533 1C3.475 1 1 3.441 1 6.455c0 1.006.278 1.947.76 2.759a9.32 9.32 0 00-.194 1.89c0 5.195 4.272 9.406 9.539 9.406.598 0 1.181-.055 1.747-.158A5.58 5.58 0 0015.47 21C18.524 21 21 18.558 21 15.546c0-.871-.207-1.692-.575-2.423zm-4.426 2.476c-.442.616-1.093 1.104-1.939 1.448-.836.344-1.838.52-2.98.52-1.37 0-2.519-.238-3.416-.708a4.434 4.434 0 01-1.57-1.375c-.407-.575-.61-1.146-.61-1.699 0-.344.133-.643.397-.886.261-.244.596-.365.997-.365.327 0 .61.096.84.287.218.184.407.457.558.805.169.383.353.705.547.957.188.246.457.45.8.612.347.16.813.244 1.386.244.789 0 1.436-.166 1.921-.494.476-.319.706-.704.706-1.174 0-.37-.121-.662-.367-.891-.26-.24-.603-.426-1.018-.555a20.235 20.235 0 00-1.75-.427c-.991-.21-1.832-.457-2.5-.738-.683-.287-1.236-.685-1.638-1.183-.41-.506-.618-1.14-.618-1.885 0-.71.218-1.35.648-1.902.426-.549 1.048-.977 1.852-1.269.791-.288 1.733-.435 2.799-.435.851 0 1.6.098 2.226.29.629.193 1.159.453 1.575.774.42.325.733.669.928 1.029.197.362.298.724.298 1.072 0 .337-.131.643-.391.908a1.32 1.32 0 01-.98.404c-.352 0-.63-.087-.821-.253-.179-.156-.365-.4-.57-.747-.238-.445-.526-.797-.856-1.045-.322-.242-.857-.362-1.594-.362-.683 0-1.24.135-1.653.403-.397.256-.591.551-.591.901 0 .214.063.393.191.546.135.165.327.306.569.426.25.124.509.224.768.294.265.073.708.181 1.32.32.772.163 1.48.347 2.108.545a6.759 6.759 0 011.634.734c.456.294.818.669 1.075 1.119.258.454.388 1.01.388 1.657a3.54 3.54 0 01-.67 2.098z"
                  fill="rgb(166,166,166)"
                  fill-rule="nonzero"
                />
              </svg>
              <span className="text-[#00000080] text-[13px]">
                exchskyofficial
              </span>
            </div>

            <div className="max-w-[250px] bg-white rounded-xl shadow-sm border p-4 flex items-center gap-3 flex-1 justify-center border border-[rgba(151,151,151,0.5)]">
              <svg width="22" height="22" xmlns="http://www.w3.org/2000/svg">
                <g fill="rgb(166,166,166)" fill-rule="nonzero">
                  <path d="M8.292 15.677v3.865a.626.626 0 001.128.37l2.26-3.077-3.388-1.158zM20.738 1.116a.625.625 0 00-.652-.045l-18.75 9.792a.627.627 0 00.087 1.145l5.212 1.782 11.1-9.492-8.59 10.35 8.737 2.985a.628.628 0 00.82-.5l2.291-15.416a.626.626 0 00-.255-.601z" />
                </g>
              </svg>
              <span className="text-[#00000080] text-[13px]">
                info@exchsky.com
              </span>
            </div>

            <div className="max-w-[250px] bg-white rounded-xl shadow-sm border p-4 flex items-center gap-3 flex-1 justify-center border border-[rgba(151,151,151,0.5)]">
              <svg
                width="22"
                height="22"
                viewBox="0 0 40 40"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M29.172 0C35.142 0 40 4.857 40 10.828v18.345C40 35.143 35.143 40 29.173 40H10.828C4.858 40 0 35.143 0 29.173V10.828C0 4.858 4.857 0 10.828 0zM20 9.063C13.97 9.063 9.063 13.969 9.063 20c0 6.03 4.906 10.937 10.937 10.937 6.03 0 10.937-4.906 10.937-10.937 0-6.03-4.906-10.937-10.937-10.937zm0 2.345c4.738 0 8.592 3.854 8.592 8.592S24.738 28.592 20 28.592 11.408 24.738 11.408 20s3.854-8.592 8.592-8.592zm11.199-6.23a3.235 3.235 0 00-3.232 3.232 3.235 3.235 0 003.232 3.232A3.235 3.235 0 0034.43 8.41a3.236 3.236 0 00-3.232-3.232zm0 2.345a.888.888 0 010 1.774.888.888 0 010-1.774z"
                  fill="rgb(166,166,166)"
                  fill-rule="nonzero"
                />
              </svg>
              <span className="text-[#00000080] text-[13px]">exchskyindia</span>
            </div>
          </div>

          <div className="relative">
            <div
              className="w-full sm:w-[700px] mx-auto mb-[30px] bg-[rgba(255,255,255,0.25)]
                    rounded-[8px] px-[10px] py-[5px] text-[rgba(0,0,0,0.6)]
                      border border-[rgba(0,0,0,0.3)] flex items-center"
            >
              {/* Hidden header (kept as in original) */}
              <h3 id="powerWrapW" style={{ display: "none" }}>
                <span>Powered by</span>
                <img
                  src="https://statics3.skyexch1.com/images/transparent.gif"
                  alt=""
                  className="inline-block ml-2"
                />
              </h3>

              <div className="licence_embed my-2 rounded-md">
                <iframe
                  title="Curacao licence"
                  src="https://licensing.gaming-curacao.com/validator/?lh=7a83475c9e54450a218a18bd28e33fad&template=seal"
                  width="150"
                  height="50"
                  style={{
                    border: "none",
                    background: "white"
                  }}
                  loading="lazy"
                  allowTransparency={true}
                />
              </div>

              <div className="flex flex-col items-end">
                <p className="text-[11px] leading-[14px]">
                  Exchsky is operated by Sky Infotech N.V. a limited liability
                  company incorporated under the laws of Curacao with company
                  Registration number 152377 with registered office at Abraham de
                  Veerstraat 9 , Curacao P.O Box 3421 and is licensed and regulated
                  by the Curacao authority as the regulatory body responsible
                  holding a (Sub-license with License number 365/JAZ Sub-License
                  GLH- OCCHKTW0707072017 granted on 6.07.2017).
                  <br />
                  Players are requested not to contact any untrusted sources for{" "}
                  <a
                    href="https://www.skyexch.art"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline"
                  >
                    https://www.skyexch.art/
                  </a>{" "}
                  accounts as this is an online site and they can only register
                  independently without any agents. Only deposit through the account
                  details generated by the system or provided by our official
                  support team.
                </p>

                <div className="footer_info mt-3 text-[11px] flex items-end justify-end border-t-[1px_solid] w-[75%]">
                  <p className="icon_phone flex items-center gap-2 mr-[30px]">
                    <svg width="14" height="14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M280 0c128.1 0 232 103.9 232 232 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-72c0-13.3 10.7-24 24-24 75.1 0 136 60.9 136 136 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88-13.3 0-24-10.7-24-24zM117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7l40.3-49.3c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512 200.6 512 0 311.4 0 64c0-18 12.1-33.8 29.5-38.6l88-24z" fill="%23000000" fill-rule="nonzero"/></svg>
                    +351926917651 / +351926917279
                  </p>
                  <p className="mt-1 ml-2">
                    <a
                      href="mailto:support@exchsky.com"
                      className="flex items-center gap-2 underline"
                    >
                      <svg width="14" height="14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4l217.6 163.2c11.4 8.5 27 8.5 38.4 0l217.6-163.2c12.1-9.1 19.2-23.3 19.2-38.4 0-26.5-21.5-48-48-48H48zM0 176v208c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V176L294.4 339.2a63.9 63.9 0 0 1-76.8 0L0 176z" fill="%23000000" fill-rule="nonzero"/></svg>
                      support@exchsky.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col items-center">
              <div className="browser-images">
                    <img src="/images/icon-browser-B.png"></img>
              </div>
              <div className="flex flex-col items-center">
                <p className="text-[#00000080] text-[11px]">Our website works best in the newest and last prior version of these browsers:</p>
                <p className="text-[#00000080] text-[11px]">Google Chrome. Firefox</p>
              </div>
          </div>
        </div>

        {/* ---------- TERMS ROW ---------- */}
        <div className="w-full mt-8 flex flex-wrap justify-center gap-3 text-sm text-gray-700 border-t border-gray-300">
          <a href="#" className="hover:underline text-[#00000099] text-[12px]">
            Privacy Policy
          </a>
          <span>-</span>
          <a href="#" className="hover:underline text-[#00000099] text-[12px] underline">
            Terms and Conditions
          </a>
          <span>-</span>
          <a href="#" className="hover:underline text-[#00000099] text-[12px] underline">
            Rules and Regulations
          </a>
          <span>-</span>
          <a href="#" className="hover:underline text-[#00000099] text-[12px] underline">
            KYC
          </a>
          <span>-</span>
          <a href="#" className="hover:underline text-[#00000099] text-[12px] underline">
            Responsible Gaming
          </a>
          <span>-</span>
          <a href="#" className="hover:underline text-[#00000099] text-[12px] underline">
            About Us
          </a>
          <span>-</span>
          <a href="#" className="hover:underline text-[#00000099] text-[12px] underline">
            Self-exclusion Policy
          </a>
          <span>-</span>
          <a href="#" className="hover:underline text-[#00000099] text-[12px] underline">
            Underage Policy
          </a>
        </div>

        {/* ANDROID APP BUTTON */}
        <div className="mt-6 flex flex-col items-center">
          <img
            src="/images/btn-appdl.png"
            alt="Android"
            className="h-[45px] w-[155px]"
          />
          <p className="text-xs text-gray-500 mt-1">
            v1.15 - 2025-09-17 - 3.1MB
          </p>
        </div>
      </div>


      {/* ----------------- MOBILE COLUMN ----------------- */}
      <div className="flex flex-col md:hidden gap-2 w-full items-center mt-[70px] mb-[60px] p-2">

        {/* ---------- TOP CONTACT BOXES ---------- */}
        <div className="w-full max-w-4xl flex flex-col gap-3 items-center">
          <div className="flex flex-col gap-2 items-center">
            {/* Customer Support */}
            <div className="w-[300px] bg-white rounded-xl shadow-sm border flex items-center justify-center gap-3 h-[45px] bg-white py-2 rounded-lg border text-[13px] justify-center">
              <svg
                width="26"
                height="26"
                viewBox="0 0 160 160"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M125.436 95.33c-.453 4.682-2.987 7.98-7.26 9.898-.83.372-1.207.754-1.295 1.729-.542 5.899-4.402 10.21-9.985 11.099-2.427.386-4.905.057-6.92.131-2.593 0-4.746.017-6.9-.01-.675-.008-1.012.24-1.248.888-1.268 3.486-3.987 5.356-7.713 5.361-2.928.006-5.855.011-8.782-.003-3.507-.017-6.301-1.867-7.428-4.89-1.2-3.216-.33-6.768 2.216-9.03 1.487-1.322 3.295-1.814 5.217-1.848a287 287 0 0 1 9.085-.007c3.334.044 6.2 2.077 7.333 5.224.277.77.65 1.032 1.45 1.024 3.904-.035 7.807.005 11.71-.023 4.399-.031 7.776-2.947 8.492-7.278.194-1.175.053-1.34-1.162-1.35-.673-.004-1.347 0-2.02 0-3.092-.006-4.605-1.5-4.606-4.566-.003-7.167-.001-14.334-.001-21.501 0-2.12-.013-4.24.004-6.36.02-2.525 1.276-4.055 3.782-4.244 3.402-.256 6.834-.295 9.92 1.514 4.001 2.346 6.15 5.912 6.243 10.526.093 4.57.31 9.157-.132 13.717M50.55 63.55c-.13.63-.317 1.05-1.07 1.061-2.795.044-5.566.365-8.318.833-.733.124-.94-.057-.873-.83.622-7.134 3.087-13.56 7.561-19.14 3.844-4.796 8.788-8.626 14.517-10.895 5.509-2.18 11.492-2.866 17.418-2.83 1.734.011 3.464.084 5.174.199 2.638.177 5.28.404 7.882.89 2.809.517 5.68 1.71 8.227 2.993a35.227 35.227 0 0 1 12.46 10.468c3.323 4.49 5.52 9.757 6.478 15.256.09.515.169 1.032.237 1.55.11.838.145 1.673.18 2.513.019.432-.152.558-.543.375-2.894-1.351-5.982-1.453-9.09-1.384-.745.016-1.047-.272-1.206-1.008-1.717-7.993-6.139-14.007-13.31-17.955a24.249 24.249 0 0 0-11.19-3.032 173.892 173.892 0 0 0-9.89-.002c-6.253.192-11.744 2.422-16.417 6.572-4.342 3.856-7.055 8.682-8.227 14.367m4.202 38.236c-.004 2.884-1.553 4.472-4.417 4.436-2.25-.029-4.51.22-6.747-.185-4.812-.87-8.388-4.805-8.648-9.688-.308-5.777-.321-11.563.016-17.34.273-4.676 4.606-8.957 9.263-9.363 1.983-.172 3.963-.172 5.946-.147 3.076.04 4.585 1.582 4.588 4.636.004 4.575.001 9.149 0 13.724 0 4.643.005 9.285-.001 13.927M79.52 0h-.04C35.646 0 0 35.656 0 79.5c0 17.39 5.605 33.509 15.135 46.597L5.227 155.63l30.558-9.769C48.355 154.19 63.351 159 79.52 159c43.834 0 79.48-35.666 79.48-79.5S123.354 0 79.52 0"
                  fill="rgb(166,166,166)"
                  fill-rule="nonzero"
                />
              </svg>
              <span className="text-[#000000b3] text-[13px]">
                Customer support1
              </span>
              <span className="text-gray-400">|</span>
              <span className="text-[#000000b3] text-[13px]">support2</span>
            </div>

            {/* Whatsapp */}
            <div className="w-[300px] bg-white rounded-xl shadow-sm border flex items-center justify-center gap-3 h-[45px] bg-white py-2 rounded-lg border text-[13px] justify-center">
              <svg width="22" height="22" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.002 1h-.005C5.485 1 1 5.485 1 11c0 2.188.705 4.215 1.904 5.861l-1.246 3.715L5.5 19.347A9.913 9.913 0 0011.002 21C16.517 21 21 16.514 21 11S16.516 1 11.002 1zm5.82 14.121c-.242.681-1.2 1.246-1.963 1.412-.523.11-1.205.2-3.503-.753-2.938-1.218-4.831-4.204-4.978-4.398-.142-.193-1.188-1.58-1.188-3.016 0-1.435.729-2.134 1.022-2.434.242-.246.64-.358 1.023-.358.124 0 .235.006.335.011.294.012.441.03.635.494.241.581.829 2.016.899 2.163.071.148.142.348.042.542-.094.2-.176.288-.324.458-.147.17-.287.3-.434.483-.136.159-.288.329-.118.622.17.288.758 1.247 1.623 2.017 1.116.993 2.02 1.311 2.345 1.446.24.1.528.076.705-.111.223-.242.5-.642.78-1.035.2-.283.453-.318.718-.218.27.094 1.699.8 1.993.946.293.148.487.218.558.342.07.123.07.705-.17 1.387z"
                  fill="rgb(166,166,166)"
                  fill-rule="nonzero"
                />
              </svg>
              <span className="text-[#000000b3] text-[13px]">WhatsApp 3</span>
              <span className="text-gray-400">|</span>
              <span className="text-[#000000b3] text-[13px]">WhatsApp 4</span>
            </div>
          </div>

          {/* Space */}
          <div className="w-[300px] bg-white rounded-xl shadow-sm border flex items-center justify-center gap-3 h-[20px] bg-white rounded-lg border text-[13px] justify-center"></div>

          {/* Bottom Contact Row */}
          <div className="w-[300px] flex items-center justify-between gap-2 flex-wrap">
            <div className="max-w-[100px] bg-white rounded-xl shadow-sm border p-1 py-2 flex items-center gap-1 flex-1 justify-center border">
              <svg width="22" height="22" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M20.425 13.123c.145-.652.22-1.327.22-2.02 0-5.193-4.27-9.404-9.539-9.404-.555 0-1.1.047-1.631.137A5.567 5.567 0 006.533 1C3.475 1 1 3.441 1 6.455c0 1.006.278 1.947.76 2.759a9.32 9.32 0 00-.194 1.89c0 5.195 4.272 9.406 9.539 9.406.598 0 1.181-.055 1.747-.158A5.58 5.58 0 0015.47 21C18.524 21 21 18.558 21 15.546c0-.871-.207-1.692-.575-2.423zm-4.426 2.476c-.442.616-1.093 1.104-1.939 1.448-.836.344-1.838.52-2.98.52-1.37 0-2.519-.238-3.416-.708a4.434 4.434 0 01-1.57-1.375c-.407-.575-.61-1.146-.61-1.699 0-.344.133-.643.397-.886.261-.244.596-.365.997-.365.327 0 .61.096.84.287.218.184.407.457.558.805.169.383.353.705.547.957.188.246.457.45.8.612.347.16.813.244 1.386.244.789 0 1.436-.166 1.921-.494.476-.319.706-.704.706-1.174 0-.37-.121-.662-.367-.891-.26-.24-.603-.426-1.018-.555a20.235 20.235 0 00-1.75-.427c-.991-.21-1.832-.457-2.5-.738-.683-.287-1.236-.685-1.638-1.183-.41-.506-.618-1.14-.618-1.885 0-.71.218-1.35.648-1.902.426-.549 1.048-.977 1.852-1.269.791-.288 1.733-.435 2.799-.435.851 0 1.6.098 2.226.29.629.193 1.159.453 1.575.774.42.325.733.669.928 1.029.197.362.298.724.298 1.072 0 .337-.131.643-.391.908a1.32 1.32 0 01-.98.404c-.352 0-.63-.087-.821-.253-.179-.156-.365-.4-.57-.747-.238-.445-.526-.797-.856-1.045-.322-.242-.857-.362-1.594-.362-.683 0-1.24.135-1.653.403-.397.256-.591.551-.591.901 0 .214.063.393.191.546.135.165.327.306.569.426.25.124.509.224.768.294.265.073.708.181 1.32.32.772.163 1.48.347 2.108.545a6.759 6.759 0 011.634.734c.456.294.818.669 1.075 1.119.258.454.388 1.01.388 1.657a3.54 3.54 0 01-.67 2.098z"
                  fill="rgb(166,166,166)"
                  fill-rule="nonzero"
                />
              </svg>
              <span className="text-[#00000080] text-[13px]">
                Skype
              </span>
            </div>

            <div className="max-w-[100px] bg-white rounded-xl shadow-sm border p-1 py-2 flex items-center gap-1 flex-1 justify-center border">
              <svg width="22" height="22" xmlns="http://www.w3.org/2000/svg">
                <g fill="rgb(166,166,166)" fill-rule="nonzero">
                  <path d="M8.292 15.677v3.865a.626.626 0 001.128.37l2.26-3.077-3.388-1.158zM20.738 1.116a.625.625 0 00-.652-.045l-18.75 9.792a.627.627 0 00.087 1.145l5.212 1.782 11.1-9.492-8.59 10.35 8.737 2.985a.628.628 0 00.82-.5l2.291-15.416a.626.626 0 00-.255-.601z" />
                </g>
              </svg>
              <span className="text-[#00000080] text-[13px]">
                Email
              </span>
            </div>

            <div className="max-w-[100px] bg-white rounded-xl shadow-sm border p-1 py-2 flex items-center gap-1 flex-1 justify-center border">
              <svg
                width="22"
                height="22"
                viewBox="0 0 40 40"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M29.172 0C35.142 0 40 4.857 40 10.828v18.345C40 35.143 35.143 40 29.173 40H10.828C4.858 40 0 35.143 0 29.173V10.828C0 4.858 4.857 0 10.828 0zM20 9.063C13.97 9.063 9.063 13.969 9.063 20c0 6.03 4.906 10.937 10.937 10.937 6.03 0 10.937-4.906 10.937-10.937 0-6.03-4.906-10.937-10.937-10.937zm0 2.345c4.738 0 8.592 3.854 8.592 8.592S24.738 28.592 20 28.592 11.408 24.738 11.408 20s3.854-8.592 8.592-8.592zm11.199-6.23a3.235 3.235 0 00-3.232 3.232 3.235 3.235 0 003.232 3.232A3.235 3.235 0 0034.43 8.41a3.236 3.236 0 00-3.232-3.232zm0 2.345a.888.888 0 010 1.774.888.888 0 010-1.774z"
                  fill="rgb(166,166,166)"
                  fill-rule="nonzero"
                />
              </svg>
              <span className="text-[#00000080] text-[13px]">exchskyindia</span>
            </div>
          </div>
        </div>

        {/* ---------- TERMS ROW ---------- */}
        <div className="w-full mt-8 flex flex-wrap justify-center gap-1 text-sm text-gray-700 border-t border-gray-300">
          <a href="#" className="hover:underline text-[#00000099] text-[12px]">
            Privacy Policy
          </a>
          <span>-</span>
          <a href="#" className="hover:underline text-[#00000099] text-[12px] underline">
            Terms and Conditions
          </a>
          <span>-</span>
          <a href="#" className="hover:underline text-[#00000099] text-[12px] underline">
            Rules and Regulations
          </a>
          <span>-</span>
          <a href="#" className="hover:underline text-[#00000099] text-[12px] underline">
            KYC
          </a>
          <span>-</span>
          <a href="#" className="hover:underline text-[#00000099] text-[12px] underline">
            Responsible Gaming
          </a>
          <span>-</span>
          <a href="#" className="hover:underline text-[#00000099] text-[12px] underline">
            About Us
          </a>
          <span>-</span>
          <a href="#" className="hover:underline text-[#00000099] text-[12px] underline">
            Self-exclusion Policy
          </a>
          <span>-</span>
          <a href="#" className="hover:underline text-[#00000099] text-[12px] underline">
            Underage Policy
          </a>
        </div>

        {/* ANDROID APP BUTTON */}
        <div className="mt-6 flex flex-col items-center">
          <img
            src="/images/btn-appdl.png"
            alt="Android"
            className="h-[45px] w-[155px]"
          />
          <p className="text-xs text-gray-500 mt-1">
            v1.15 - 2025-09-17 - 3.1MB
          </p>
        </div>

      </div>
    </>
  );
}
